import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
import { useAlert } from '../../../components/Notification';
import { EmailInput, PasswordInput } from '../../../components/TextFields';
import { handleLogin } from '../../../stores/services/authApis/index';
import { setLoginAction } from '../../../stores/actionTypes/authActions/index';
import { hashPassword } from '../../../constant/constant';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailValid, setisEmailValid] = useState(false);
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState<any>({
    email: false,
    password: false,
  });
  const [handleMultipleApi, setHandleMultipleApi] = useState(true);
  const showAlert = useAlert();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`; // Replace with your reCAPTCHA site key
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    // Hide the reCAPTCHA badge
    const hideBadge = () => {
      const badge = document.querySelector('.grecaptcha-badge') as HTMLElement; // Type assertion
      if (badge) {
        badge.style.display = 'none';
      }
    };

    // show the reCAPTCHA badge
    const showBadge = () => {
      const badge = document.querySelector('.grecaptcha-badge') as HTMLElement; // Type assertion
      if (badge) {
        badge.style.display = 'block';
      }
    };

    // Wait for the script to load before hiding the badge
    script.onload = showBadge;

    // Cleanup function to remove the script
    return () => {
      document.body.removeChild(script);
      hideBadge(); // Hide badge again when unmounting
    };
  }, []);

  const login = async () => {
    if (!handleMultipleApi) return; // Exit if handleMultipleApi is false
    setHandleMultipleApi(false);

    const recaptchaToken = await window.grecaptcha.enterprise.execute(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY,
      { action: 'LOGIN' },
    );
    if (recaptchaToken) {
      await handleLogin({
        username: email,
        password: hashPassword(password),
        captchaToken: recaptchaToken,
      })
        .then((response) => {
          const { error, data } = response.data;
          if (error) {
            showAlert('Invalid credential', 'error');
            return;
          }
          showAlert('Login Successfully', 'success');
          localStorage.setItem('ICEMAKE', data);
          localStorage.setItem('role', 'admin');
          dispatch(setLoginAction(data));
          navigate('/dashboard');
        })
        .catch(() => {
          showAlert('Invalid credential', 'error');
          setHandleMultipleApi(true);
        });
    } else {
      console.log('Invalid recaptcha token');
      setHandleMultipleApi(true);
    }
  };

  const validation = () => {
    if (email?.trim()?.length === 0 && password?.trim()?.length === 0) {
      setLoginErrorMessage({ email: true, password: true });
    } else if (email?.trim()?.length === 0) {
      setLoginErrorMessage({ email: true, password: false });
    } else if (password?.trim()?.length === 0) {
      setLoginErrorMessage({ email: false, password: true });
    }
  };

  const onEnetrKeyPress = () => {
    if (isEmailValid && isPasswordValid) {
      login();
    } else {
      validation();
    }
  };

  const handleChangeEmail = (value: React.SetStateAction<string>) => {
    setEmail(value);
    setLoginErrorMessage((prev: any) => {
      return { ...prev, email: false };
    });
  };

  const handleChangePassword = (value: React.SetStateAction<string>) => {
    setPassword(value);
    setLoginErrorMessage((prev: any) => {
      return { ...prev, password: false };
    });
  };

  return (
    <>
      <div className="form_header">
        <Typography variant="h5" align="center" fontWeight="bold">
          Sign In
        </Typography>
      </div>
      <div className="auth_form">
        <div className="auth_formitem">
          <div className="form-input">
            <EmailInput
              value={email}
              handleValid={setisEmailValid}
              onKeyDown={onEnetrKeyPress}
              onChange={handleChangeEmail}
              error={isEmailValid}
              errormessage={loginErrorMessage?.email}
            />
          </div>
          <div className="form-input">
            <PasswordInput
              value={password}
              handleValid={setisPasswordValid}
              onChange={handleChangePassword}
              onKeyDown={onEnetrKeyPress}
              error={isPasswordValid}
              errormessage={loginErrorMessage?.password}
            />
          </div>

          <Typography variant="body2" align="right">
            <RouterLink className="routerLink" to="/forgot-password">
              Forgot Password?
            </RouterLink>
          </Typography>
        </div>

        <Divider component="div" role="presentation" />
        <div className="auth_formitem">
          <button
            name="submit"
            className="submit_Button"
            color="primary"
            disabled={!(isEmailValid && isPasswordValid)}
            onClick={() => login()}
          >
            Sign In
          </button>
        </div>

        {/* <Divider component="div" role="presentation" /> */}
      

        <div></div>

        
      </div>

        <div style={{
          // border:"1px solid black",
          marginTop:10,
          padding:10
        }} 
        // className="auth_formitem"
        className="auth_form"
        >
      
      <Typography
            variant="body2"
            align="center"
            className="submit_Button-text"
          >
            <a
          href={process.env.REACT_APP_DEALER_DASHBOARD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="routerLink"
            >
              Dealer Login
            </a>
          </Typography>
         
    
        </div>
    </>
  );
};

export default connect((assets) => assets, {
  handleLogin,
})(SignIn);
